import { PLAYER } from "./players";

export enum TEAM {
  ONE = "team1",
  TWO = "team2"
}

export const PlayerTeamIdx = {
  [PLAYER.FIRST]: 0,
  [PLAYER.SECOND]: 0,
  [PLAYER.THIRD]: 1,
  [PLAYER.FOURTH]: 1,
}

export const teamOnePlayers = [PLAYER.FIRST, PLAYER.THIRD];
export const teamTwoPlayers = [PLAYER.SECOND, PLAYER.FOURTH];